import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "text-positive" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" / ")
const _hoisted_5 = { class: "text-negative" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col q-px-md q-pb-md" }
const _hoisted_8 = {
  key: 0,
  class: "col q-pa-md"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_space = _resolveComponent("q-space")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_VehicleWithdrawalTable = _resolveComponent("VehicleWithdrawalTable")!
  const _component_VehicleWithdrawalReportStatusTable = _resolveComponent("VehicleWithdrawalReportStatusTable")!
  const _component_q_page = _resolveComponent("q-page")!

  return (_openBlock(), _createBlock(_component_q_page, null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", {
          class: _normalizeClass(_ctx.showVehicleStatusMenu ? 'col-9' : 'col')
        }, [
          _createElementVNode("div", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item, $i) => {
              return (_openBlock(), _createElementBlock("div", {
                key: $i,
                class: "col q-pa-md"
              }, [
                _createVNode(_component_q_card, { square: "" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_q_card_section, {
                      horizontal: "",
                      class: "q-pa-none"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_card_section, null, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(item.label), 1)
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_q_space),
                        _createVNode(_component_q_separator, { vertical: "" }),
                        _createVNode(_component_q_card_section, { class: "text-weight-bold" }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_3, _toDisplayString(item.value.available), 1),
                            _hoisted_4,
                            _createElementVNode("span", _hoisted_5, _toDisplayString(item.value.withdrawn), 1),
                            _createTextVNode(" (" + _toDisplayString(item.value.total) + ") ", 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024)
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_q_card, { square: "" }, {
                default: _withCtx(() => [
                  _createVNode(_component_VehicleWithdrawalTable)
                ]),
                _: 1
              })
            ])
          ])
        ], 2),
        (_ctx.showVehicleStatusMenu)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createVNode(_component_VehicleWithdrawalReportStatusTable)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}